// src/config.js

// A URL base da sua API. Altere aqui quando precisar.
//const API_BASE_URL = 'https://cockpit.arpsoftware.com.br';

// Em ambiente de desenvolvimento local, você pode descomentar a linha abaixo
// e comentar a de cima.
const API_BASE_URL = 'http://localhost:8082';

export { API_BASE_URL };